/* returns-onne.js — ONNE "Devoluciones" wizard (estilo Hawkers, gateado).
   Custom element <returns-onne>. Pasos: Identificar → Artículos → Confirmar → Listo.
   Endpoints (todos resuelven el order_gid DESDE el token de order/lookup):
     POST {endpoint}/api/support/order/lookup   → token (D-11)
     POST {endpoint}/api/support/return/items    {support_session_token}
     POST {endpoint}/api/support/return/create   {support_session_token, items:[{fulfillment_line_item_id, qty, motivo, sub_choice?}], lang}
   Reglas duras: NUNCA dice "reembolso hecho" (el ack viene del server: "solicitud recibida" + 72h Elda);
   defectuoso → ticket Calidad (no returnRequest); higiene swim/íntimo = autoatestación 3 checks.
   Gateado por SUPPORT_RETURNS_ENABLED → 503 {disabled} → estado "muy pronto/ajustes".
   Horizon-ONNE conventions (handbook 09): custom element, connectedCallback, sin IIFE. */

const RCOPY = {
  es: {
    title: 'Devoluciones', subtitle: 'Tramita tu devolución en unos pasos',
    steps: ['Identificar', 'Artículos', 'Confirmar', 'Listo'],
    cond_title: 'Antes de empezar, lo esencial',
    cond: [
      'Tienes 30 días desde el envío de tu pedido para solicitar la devolución.',
      'Vuelve en perfecto estado: sin usar, con etiquetas, sello de higiene y embalaje original.',
      'La etiqueta es gratis: la generas en nuestro portal al terminar este formulario. Mensajería con seguimiento.',
      'Te reembolsamos tras revisarlo en Elda, normalmente en ~72h desde que llega.',
    ],
    order_label: 'Número de pedido', order_ph: 'Empieza por ONNE o por #',
    factor_label: 'Email o últimos 4 del teléfono', factor_help: 'El que usaste en la compra', factor_ph: 'tu@email.com',
    cta_start: 'Empezar devolución', no_order: 'No encuentro mi número de pedido',
    loading: 'Un momento…',
    items_title: '¿Qué quieres devolver?', qty: 'Uds.',
    motivo_label: 'Motivo',
    motivo_size: 'Es cuestión de talla', motivo_unwanted: 'No es para mí', motivo_defective: 'Llegó defectuoso o dañado',
    size_smaller: 'Me queda pequeña', size_bigger: 'Me queda grande',
    need_selection: 'Selecciona al menos un artículo y su motivo 🤍',
    cta_continue: 'Continuar',
    hygiene_title: 'Confírmanos que está como nueva',
    hcheck1: 'Conserva sus etiquetas', hcheck2: 'Va en su embalaje original', hcheck3: 'El sello de higiene está intacto',
    hygiene_note: 'Por higiene, si se ha probado o usado en zona íntima sin el sello, no podemos aceptarla. Gracias por ayudarnos a cuidar de todas ✨',
    need_hygiene: 'Marca las tres casillas para continuar 🤍',
    cta_submit: 'Enviar solicitud',
    defective_title: 'Cuéntanos qué ha pasado',
    defective_intro: 'Sentimos mucho que no haya llegado perfecto 🤍 Lo revisa nuestro equipo de Calidad; los productos ÔNNE están cubiertos por la garantía legal de 3 años.',
    defective_note_label: '¿Qué le pasa?', defective_note_ph: 'Describe el defecto…',
    defective_photos_label: 'Añade fotos (hasta 3)', defective_photos_hint: 'Donde se vea bien el defecto. Máx. 3 imágenes de 5 MB.',
    cta_send_defective: 'Enviar a Calidad',
    talk_team: 'Hablar con el equipo', retry: 'Intentar de nuevo', back: 'Volver',
    new_order_cta: 'Hacer mi nuevo pedido',
    size_change_note: 'Aceptamos cambios por otra talla, color u otro producto, o la devolución del dinero. Para el cambio, devuelves el original y haces un pedido nuevo.',
    service_unavailable: 'Estamos haciendo unos ajustes y esta opción no está disponible ahora mismo. Vuelve en un ratito o escríbenos 🤍',
    network_error: 'Ups, no hemos podido conectar. ¿Probamos otra vez?',
    no_order_graceful: '¿No encuentras tu número de pedido? Sin problema 🤍 Suele estar en el email de confirmación (busca «ÔNNE»). Si no lo localizas, te paso con nuestro equipo y lo encontramos contigo.',
    find_title: 'Te buscamos tu pedido',
    find_intro: 'Dinos el email y el teléfono (últimos 4) o el código postal de la compra y te buscamos el pedido para empezar la devolución 🤍',
    find_email_label: 'Email de la compra',
    find_email_ph: 'tu@email.com',
    find_factor_label: 'Teléfono (últimos 4) o código postal',
    find_factor_ph: 'Ej. 1234 o 03600',
    find_cta: 'Buscar mi pedido',
    find_not_found: 'No hemos podido verificarlo con esos datos y no quiero abrir una devolución de un pedido que no sea tuyo. 🤍 Te paso con nuestro equipo para encontrarlo contigo.',
    need_email: 'Necesitamos un email válido 🤍',
    need_find_factor: 'Añade el teléfono (últimos 4) o el código postal de la compra 🤍',
    nothing_returnable: 'No vemos artículos disponibles para devolver en este pedido. Si crees que es un error, te paso con nuestro equipo 🤍',
    return_type_title: '¿Qué tipo de devolución es?',
    rt_standard: 'Cambio de talla, color o no es para mí',
    rt_standard_help: 'Te llevamos a nuestro portal para elegir los artículos y obtener tu etiqueta.',
    rt_defective: 'Llegó defectuoso o dañado',
    rt_defective_help: 'Lo revisa nuestro equipo de Calidad (garantía legal de 3 años).',
    portal_title: 'Termina tu devolución en el portal',
    portal_intro: 'Abriremos nuestro portal de devoluciones para que elijas los artículos, el motivo y obtengas tu etiqueta de envío.',
    portal_cta: 'Ir al portal de devoluciones',
    portal_order_label: 'Tu número de pedido',
    portal_note_fallback: 'La etiqueta de devolución es gratis. La generas y la descargas en el portal.'
  },
  en: {
    title: 'Returns', subtitle: 'Start your return in a few steps',
    steps: ['Identify', 'Items', 'Confirm', 'Done'],
    cond_title: 'Before we start, the essentials',
    cond: [
      'You have 30 days from the dispatch of your order to request the return.',
      'It must come back in perfect condition: unused, with tags, hygiene seal and original packaging.',
      'The label is free: you generate it in our portal once you finish this form. Tracked courier.',
      'We refund after checking it in Elda, usually within ~72h of arrival.',
    ],
    order_label: 'Order number', order_ph: 'Starts with ONNE or #',
    factor_label: 'Email or last 4 of phone', factor_help: 'The one used at checkout', factor_ph: 'you@email.com',
    cta_start: 'Start return', no_order: "I can't find my order number",
    loading: 'One moment…',
    items_title: 'What would you like to return?', qty: 'Qty',
    motivo_label: 'Reason',
    motivo_size: "It's a sizing thing", motivo_unwanted: 'Not for me', motivo_defective: 'Arrived faulty or damaged',
    size_smaller: 'Runs small', size_bigger: 'Runs large',
    need_selection: 'Select at least one item and its reason 🤍',
    cta_continue: 'Continue',
    hygiene_title: "Confirm it's as good as new",
    hcheck1: 'Still has its tags', hcheck2: 'In its original packaging', hcheck3: 'The hygiene seal is intact',
    hygiene_note: "For hygiene, if it's been tried on or worn in the intimate area without the seal, we can't accept it. Thanks for helping us look after everyone ✨",
    need_hygiene: 'Tick all three boxes to continue 🤍',
    cta_submit: 'Send request',
    defective_title: 'Tell us what happened',
    defective_intro: "We're so sorry it didn't arrive perfect 🤍 Our Quality team reviews it; ÔNNE products are covered by the 3-year legal guarantee.",
    defective_note_label: "What's wrong?", defective_note_ph: 'Describe the fault…',
    defective_photos_label: 'Add photos (up to 3)', defective_photos_hint: 'Where the fault is clearly visible. Max 3 images of 5 MB.',
    cta_send_defective: 'Send to Quality',
    talk_team: 'Talk to our team', retry: 'Try again', back: 'Back',
    new_order_cta: 'Place my new order',
    size_change_note: 'We accept exchanges for another size, colour or item, or a money refund. For an exchange, you return the original and place a new order.',
    service_unavailable: "We're making a few tweaks and this isn't available right now. Check back in a bit or write to us 🤍",
    network_error: "Oops, we couldn't connect. Shall we try again?",
    no_order_graceful: "Can't find your order number? No problem 🤍 It's usually in your confirmation email (search «ÔNNE»). If you can't find it, I'll connect you with our team and we'll find it together.",
    find_title: "Let's find your order",
    find_intro: "Tell us the email and the phone (last 4) or postal code from your purchase and we'll find your order to start the return 🤍",
    find_email_label: 'Email used at checkout',
    find_email_ph: 'you@email.com',
    find_factor_label: 'Phone (last 4) or postal code',
    find_factor_ph: 'e.g. 1234 or 03600',
    find_cta: 'Find my order',
    find_not_found: "We couldn't verify it with those details and I don't want to open a return for an order that isn't yours. 🤍 I'll connect you with our team to find it together.",
    need_email: 'We need a valid email 🤍',
    need_find_factor: 'Add the phone (last 4) or the postal code from your purchase 🤍',
    nothing_returnable: "We don't see items available to return on this order. If you think that's a mistake, I'll connect you with our team 🤍",
    return_type_title: 'What kind of return is this?',
    rt_standard: 'Size or colour change, or not for me',
    rt_standard_help: "We'll take you to our portal to pick the items and get your label.",
    rt_defective: 'Arrived faulty or damaged',
    rt_defective_help: 'Our Quality team reviews it (3-year legal guarantee).',
    portal_title: 'Finish your return in the portal',
    portal_intro: "We'll open our returns portal so you can pick the items, the reason and get your shipping label.",
    portal_cta: 'Go to the returns portal',
    portal_order_label: 'Your order number',
    portal_note_fallback: 'The return label is free. You generate and download it in the portal.'
  },
  it: {
    title: 'Resi', subtitle: 'Gestisci il reso in pochi passi',
    steps: ['Identifica', 'Articoli', 'Conferma', 'Fatto'],
    cond_title: "Prima di iniziare, l'essenziale",
    cond: [
      "Hai 30 giorni dalla spedizione del tuo ordine per richiedere il reso.",
      "Deve tornare in perfette condizioni: non usato, con etichette, sigillo igienico e imballaggio originale.",
      "L'etichetta è gratuita: la generi nel nostro portale al termine di questo modulo. Corriere tracciato.",
      "Ti rimborsiamo dopo averlo controllato a Elda, di solito entro ~72h dall'arrivo.",
    ],
    order_label: "Numero d'ordine", order_ph: 'Inizia con ONNE o con #',
    factor_label: 'Email o ultime 4 del telefono', factor_help: "Quello usato all'acquisto", factor_ph: 'tu@email.com',
    cta_start: 'Inizia il reso', no_order: "Non trovo il mio numero d'ordine",
    loading: 'Un attimo…',
    items_title: 'Cosa vuoi restituire?', qty: 'Qtà',
    motivo_label: 'Motivo',
    motivo_size: 'È una questione di taglia', motivo_unwanted: 'Non fa per me', motivo_defective: 'Arrivato difettoso o danneggiato',
    size_smaller: 'Veste piccola', size_bigger: 'Veste grande',
    need_selection: 'Seleziona almeno un articolo e il motivo 🤍',
    cta_continue: 'Continua',
    hygiene_title: 'Conferma che è come nuovo',
    hcheck1: 'Ha ancora le etichette', hcheck2: 'Nel suo imballaggio originale', hcheck3: 'Il sigillo igienico è intatto',
    hygiene_note: "Per igiene, se è stato provato o indossato nella zona intima senza il sigillo, non possiamo accettarlo. Grazie per aiutarci a tutelare tutte ✨",
    need_hygiene: 'Spunta le tre caselle per continuare 🤍',
    cta_submit: 'Invia richiesta',
    defective_title: 'Raccontaci cosa è successo',
    defective_intro: 'Ci dispiace molto che non sia arrivato perfetto 🤍 Lo esamina il nostro team Qualità; i prodotti ÔNNE sono coperti dalla garanzia legale di 3 anni.',
    defective_note_label: 'Qual è il problema?', defective_note_ph: 'Descrivi il difetto…',
    defective_photos_label: 'Aggiungi foto (fino a 3)', defective_photos_hint: 'Dove si vede bene il difetto. Max 3 immagini da 5 MB.',
    cta_send_defective: 'Invia a Qualità',
    talk_team: 'Parla con il team', retry: 'Riprova', back: 'Indietro',
    new_order_cta: 'Fai il mio nuovo ordine',
    size_change_note: "Accettiamo cambi con un'altra taglia, colore o articolo, oppure il rimborso in denaro. Per il cambio, restituisci l'originale ed effettui un nuovo ordine.",
    service_unavailable: "Stiamo facendo alcune modifiche e ora non è disponibile. Torna tra poco o scrivici 🤍",
    network_error: 'Ops, non siamo riusciti a connetterci. Riproviamo?',
    no_order_graceful: "Non trovi il numero d'ordine? Nessun problema 🤍 Di solito è nell'email di conferma (cerca «ÔNNE»). Se non lo trovi, ti metto in contatto con il team e lo troviamo insieme.",
    find_title: 'Troviamo il tuo ordine',
    find_intro: "Dicci l'email e il telefono (ultime 4) o il codice postale dell'acquisto e troviamo il tuo ordine per avviare il reso 🤍",
    find_email_label: "Email dell'acquisto",
    find_email_ph: 'tu@email.com',
    find_factor_label: 'Telefono (ultime 4) o codice postale',
    find_factor_ph: 'Es. 1234 o 03600',
    find_cta: 'Trova il mio ordine',
    find_not_found: "Non siamo riusciti a verificarlo con questi dati e non voglio aprire un reso per un ordine che non è tuo. 🤍 Ti metto in contatto con il team per trovarlo insieme.",
    need_email: "Ci serve un'email valida 🤍",
    need_find_factor: "Aggiungi il telefono (ultime 4) o il codice postale dell'acquisto 🤍",
    nothing_returnable: 'Non vediamo articoli disponibili per il reso in questo ordine. Se pensi sia un errore, ti metto in contatto con il team 🤍',
    return_type_title: 'Che tipo di reso è?',
    rt_standard: 'Cambio taglia, colore o non fa per me',
    rt_standard_help: "Ti portiamo al nostro portale per scegliere gli articoli e ottenere l'etichetta.",
    rt_defective: 'Arrivato difettoso o danneggiato',
    rt_defective_help: 'Lo controlla il nostro team Qualità (garanzia legale di 3 anni).',
    portal_title: 'Completa il reso nel portale',
    portal_intro: "Apriremo il nostro portale resi per scegliere gli articoli, il motivo e ottenere l'etichetta di spedizione.",
    portal_cta: 'Vai al portale resi',
    portal_order_label: "Il tuo numero d'ordine",
    portal_note_fallback: "L'etichetta di reso è gratuita. La generi e la scarichi nel portale."
  },
  pt: {
    title: 'Devoluções', subtitle: 'Trata a tua devolução em poucos passos',
    steps: ['Identificar', 'Artigos', 'Confirmar', 'Pronto'],
    cond_title: 'Antes de começar, o essencial',
    cond: [
      'Tens 30 dias desde o envio da tua encomenda para solicitar a devolução.',
      'Volta em perfeito estado: sem uso, com etiquetas, selo de higiene e embalagem original.',
      'A etiqueta é gratuita: podes gerá-la no nosso portal ao terminar este formulário. Transportadora com seguimento.',
      'Reembolsamos depois de o verificar em Elda, normalmente em ~72h desde que chega.',
    ],
    order_label: 'Número da encomenda', order_ph: 'Começa por ONNE ou por #',
    factor_label: 'Email ou últimos 4 do telemóvel', factor_help: 'O que usaste na compra', factor_ph: 'tu@email.com',
    cta_start: 'Começar devolução', no_order: 'Não encontro o meu número de encomenda',
    loading: 'Um momento…',
    items_title: 'O que queres devolver?', qty: 'Qtd',
    motivo_label: 'Motivo',
    motivo_size: 'É uma questão de tamanho', motivo_unwanted: 'Não é para mim', motivo_defective: 'Chegou defeituoso ou danificado',
    size_smaller: 'Fica pequena', size_bigger: 'Fica grande',
    need_selection: 'Seleciona pelo menos um artigo e o motivo 🤍',
    cta_continue: 'Continuar',
    hygiene_title: 'Confirma que está como nova',
    hcheck1: 'Mantém as etiquetas', hcheck2: 'Na embalagem original', hcheck3: 'O selo de higiene está intacto',
    hygiene_note: 'Por higiene, se foi experimentada ou usada na zona íntima sem o selo, não podemos aceitá-la. Obrigada por nos ajudares a cuidar de todas ✨',
    need_hygiene: 'Marca as três caixas para continuar 🤍',
    cta_submit: 'Enviar pedido',
    defective_title: 'Conta-nos o que aconteceu',
    defective_intro: 'Lamentamos muito que não tenha chegado perfeito 🤍 A nossa equipa de Qualidade analisa; os produtos ÔNNE têm a garantia legal de 3 anos.',
    defective_note_label: 'Qual é o problema?', defective_note_ph: 'Descreve o defeito…',
    defective_photos_label: 'Adiciona fotos (até 3)', defective_photos_hint: 'Onde se veja bem o defeito. Máx. 3 imagens de 5 MB.',
    cta_send_defective: 'Enviar à Qualidade',
    talk_team: 'Falar com a equipa', retry: 'Tentar de novo', back: 'Voltar',
    new_order_cta: 'Fazer a minha nova encomenda',
    size_change_note: 'Aceitamos trocas por outro tamanho, cor ou artigo, ou o reembolso em dinheiro. Para a troca, devolves o original e fazes uma nova encomenda.',
    service_unavailable: 'Estamos a fazer uns ajustes e isto não está disponível agora. Volta daqui a pouco ou escreve-nos 🤍',
    network_error: 'Ups, não conseguimos ligar. Tentamos de novo?',
    no_order_graceful: 'Não encontras o número da encomenda? Sem problema 🤍 Costuma estar no email de confirmação (procura «ÔNNE»). Se não o encontrares, ponho-te em contacto com a equipa e encontramo-lo contigo.',
    find_title: 'Encontramos a tua encomenda',
    find_intro: 'Diz-nos o email e o telefone (últimos 4) ou o código postal da compra e encontramos a tua encomenda para começar a devolução 🤍',
    find_email_label: 'Email da compra',
    find_email_ph: 'tu@email.com',
    find_factor_label: 'Telefone (últimos 4) ou código postal',
    find_factor_ph: 'Ex. 1234 ou 03600',
    find_cta: 'Encontrar a minha encomenda',
    find_not_found: 'Não conseguimos verificar com esses dados e não quero abrir uma devolução de uma encomenda que não seja tua. 🤍 Ponho-te em contacto com a equipa para a encontrar contigo.',
    need_email: 'Precisamos de um email válido 🤍',
    need_find_factor: 'Adiciona o telefone (últimos 4) ou o código postal da compra 🤍',
    nothing_returnable: 'Não vemos artigos disponíveis para devolver nesta encomenda. Se achas que é um erro, ponho-te em contacto com a equipa 🤍',
    return_type_title: 'Que tipo de devolução é?',
    rt_standard: 'Troca de tamanho, cor ou não é para mim',
    rt_standard_help: 'Levamos-te ao nosso portal para escolher os artigos e obter a tua etiqueta.',
    rt_defective: 'Chegou defeituoso ou danificado',
    rt_defective_help: 'A nossa equipa de Qualidade analisa (garantia legal de 3 anos).',
    portal_title: 'Termina a tua devolução no portal',
    portal_intro: 'Vamos abrir o nosso portal de devoluções para escolheres os artigos, o motivo e obteres a tua etiqueta de envio.',
    portal_cta: 'Ir para o portal de devoluções',
    portal_order_label: 'O teu número de encomenda',
    portal_note_fallback: 'A etiqueta de devolução é gratuita. Podes gerá-la e descarregá-la no portal.'
  },
};

const RICON_CHECK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 8.5l3 3 6-6.5"/></svg>';

class ReturnsOnne extends HTMLElement {
  connectedCallback() {
    // Language: prefer the visitor's BROWSER language. The storefront has a single
    // published locale (EN), so data-lang is always 'en' and useless as a signal —
    // a Spanish visitor would otherwise see the whole wizard in English. Falls back
    // to data-lang, then 'es' (the brand default + the wizard's own ES fallback).
    const _supp = ['es', 'en', 'it', 'pt'];
    const _pick = (v) => { v = (v || '').slice(0, 2).toLowerCase(); return _supp.indexOf(v) >= 0 ? v : ''; };
    const lang = _pick(this.dataset.lang) || _pick(navigator.language) || 'en';
    this.t = RCOPY[lang] || RCOPY.es;
    this.lang = RCOPY[lang] ? lang : 'es';
    this.endpoint = (this.dataset.endpoint || '').replace(/\/+$/, '');
    this.contact = this.dataset.contact || 'mailto:info@onne.com';
    this.demo = this.dataset.demo === 'on';
    this.root = this.querySelector('[data-returns-root]') || this;
    this.token = null;
    this.items = [];          // returnable items from the server
    this.selection = {};      // fli_id -> {qty, motivo, sub_choice}
    this.renderIdentify();
  }

  _set(html) { this.root.innerHTML = html; }
  _api(path) { return `${this.endpoint}${path}`; }
  _talk() { return `<a class="support-onne__link support-onne__link--center" href="${this.contact}">${this.t.talk_team}</a>`; }

  _stepper(active) {
    const cells = this.t.steps.map((label, i) => {
      const cls = i < active ? 'order-status-onne__step--done' : (i === active ? 'order-status-onne__step--current' : '');
      const dot = i < active ? RICON_CHECK : (i + 1);
      const line = i < this.t.steps.length - 1 ? `<div class="order-status-onne__line${i < active ? ' order-status-onne__line--done' : ''}"></div>` : '';
      return `<div class="order-status-onne__step ${cls}"><div class="order-status-onne__dot">${dot}</div><div class="order-status-onne__step-label">${label}</div></div>${line}`;
    }).join('');
    return `<div class="order-status-onne__stepper">${cells}</div>`;
  }

  _conditions() {
    return `<div class="returns-onne__conditions-wrap">
      <p class="returns-onne__conditions-title">${this.t.cond_title}</p>
      <ul class="returns-onne__conditions">${this.t.cond.map(c => `<li>${c}</li>`).join('')}</ul>
    </div>`;
  }

  _detectFactor(raw) {
    const v = (raw || '').trim();
    if (v.includes('@')) return { email: v };
    const d = v.replace(/\D/g, '');
    if (d.length >= 4) return { phone_last4: d.slice(-4) };
    return null;
  }

  // ---------------------------------------------------------------- Step 1: identify
  renderIdentify(notice) {
    const t = this.t;
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <p class="support-onne__subtitle">${t.subtitle}</p>
      ${this._stepper(0)}
      ${notice ? `<div class="support-onne__state" style="margin-bottom:1.25rem"><p class="support-onne__state-msg">${notice}</p></div>` : ''}
      <div class="returns-onne__layout">
        ${this._conditions()}
        <form class="support-onne__card" data-form novalidate>
          <div class="support-onne__field" data-field-order>
            <label class="support-onne__label" for="r-order">${t.order_label}</label>
            <input class="support-onne__input" id="r-order" type="text" autocomplete="off" placeholder="${t.order_ph}">
            <p class="support-onne__error" data-err-order hidden></p>
          </div>
          <div class="support-onne__field" data-field-factor>
            <label class="support-onne__label" for="r-factor">${t.factor_label}</label>
            <input class="support-onne__input" id="r-factor" type="text" autocomplete="off" placeholder="${t.factor_ph}">
            <p class="support-onne__help">${t.factor_help}</p>
            <p class="support-onne__error" data-err-factor hidden></p>
          </div>
          <button class="support-onne__btn" type="submit">${t.cta_start}</button>
          <button class="support-onne__link support-onne__link--center" type="button" data-no-order>${t.no_order}</button>
        </form>
      </div>
    `);
    const form = this.root.querySelector('[data-form]');
    form.addEventListener('submit', (e) => { e.preventDefault(); this._onIdentify(form); });
    this.root.querySelector('[data-no-order]').addEventListener('click', () => this.renderNoOrder());
  }

  _fieldErr(form, which, msg) {
    form.querySelector(`[data-field-${which}]`).classList.add('support-onne__field--error');
    const e = form.querySelector(`[data-err-${which}]`); e.textContent = msg; e.hidden = false;
  }

  _onIdentify(form) {
    form.querySelectorAll('.support-onne__field').forEach(f => f.classList.remove('support-onne__field--error'));
    form.querySelectorAll('.support-onne__error').forEach(e => { e.hidden = true; });
    const order = form.querySelector('#r-order').value.trim();
    const factor = this._detectFactor(form.querySelector('#r-factor').value);
    let bad = false;
    if (!order) { this._fieldErr(form, 'order', this.t.order_label); bad = true; }
    if (!factor) { this._fieldErr(form, 'factor', this.t.factor_label); bad = true; }
    if (bad) return;
    this.factorEmail = (factor && factor.email) ? factor.email : null;
    this._lookup(order, factor);
  }

  renderLoading() { this._set(`<div class="support-onne__loading" role="status" aria-live="polite">${this.t.loading}</div>`); }

  async _lookup(order, factor) {
    this.renderLoading();
    if (this.demo) { this.token = 'demo'; return this.renderReturnType(); }
    if (!this.endpoint) return this.renderUnavailable();
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/order/lookup'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_number: order, second_factor: factor, lang: this.lang }),
      });
    } catch (e) { return this.renderNetworkError(() => this._lookup(order, factor)); }
    if (resp.status === 503) return this.renderUnavailable();
    try { data = await resp.json(); } catch (e) { return this.renderNetworkError(() => this._lookup(order, factor)); }
    if (!data || data.verified !== true || !data.support_session_token) {
      return this.renderIdentify(this.t.no_order_graceful);
    }
    this.token = data.support_session_token;
    this.renderReturnType();
  }

  // ------------------------------------------------ Step 2: type of return (B)
  // Option B (Diego 2026-06-17): our wizard does D-11 + this branch; the branded
  // SendCloud portal does items + reason + drop-off label. Defective stays in our
  // Quality flow (photos → ticket). Standard → handoff to the portal.
  renderReturnType() {
    const t = this.t;
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      ${this._stepper(1)}
      <div class="support-onne__card support-onne__card--narrow">
        <p class="returns-onne__items-title">${t.return_type_title}</p>
        <button class="returns-onne__choice" type="button" data-standard>
          <span class="returns-onne__choice-t">${t.rt_standard}</span>
          <span class="returns-onne__choice-h">${t.rt_standard_help}</span>
        </button>
        <button class="returns-onne__choice" type="button" data-defective>
          <span class="returns-onne__choice-t">${t.rt_defective}</span>
          <span class="returns-onne__choice-h">${t.rt_defective_help}</span>
        </button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    this.root.querySelector('[data-standard]').addEventListener('click', () => this.renderPortalHandoff());
    this.root.querySelector('[data-defective]').addEventListener('click', () => this.renderDefective());
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderIdentify());
  }

  // ---------------------------------------------- Step 3 (standard): portal handoff
  async renderPortalHandoff() {
    this.renderLoading();
    if (this.demo) {
      return this._showPortal({ portal_url: 'https://onne.shipping-portal.com',
        order_number: 'ONNE12345', return_cost_notice: this.t.portal_note_fallback });
    }
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/return/portal-link'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ support_session_token: this.token, lang: this.lang }),
      });
    } catch (e) { return this.renderNetworkError(() => this.renderPortalHandoff()); }
    if (resp.status === 503) return this.renderUnavailable();
    try { data = await resp.json(); } catch (e) { return this.renderNetworkError(() => this.renderPortalHandoff()); }
    if (!data || !data.portal_url) return this.renderState(this.t.service_unavailable, true);
    this._showPortal(data);
  }

  _showPortal(data) {
    const t = this.t;
    const order = data.order_number || '';
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      ${this._stepper(2)}
      <div class="support-onne__card support-onne__card--narrow">
        <p class="returns-onne__items-title">${t.portal_title}</p>
        <p class="support-onne__help" style="margin-top:0">${t.portal_intro}</p>
        <div class="returns-onne__portal-notice"><span data-notice></span></div>
        ${order ? `<p class="support-onne__help">${t.portal_order_label}: <b data-order></b></p>` : ''}
        <a class="support-onne__btn" data-portal target="_blank" rel="noopener">${t.portal_cta}</a>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    // Set dynamic values via textContent / setAttribute (no HTML injection).
    this.root.querySelector('[data-notice]').textContent = data.return_cost_notice || t.portal_note_fallback;
    if (order) this.root.querySelector('[data-order]').textContent = order;
    this.root.querySelector('[data-portal]').setAttribute('href', data.portal_url);
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderReturnType());
  }

  // ---------------------------------------------------------------- Step 2: items
  async _fetchItems() {
    this.renderLoading();
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/return/items'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ support_session_token: this.token }),
      });
    } catch (e) { return this.renderNetworkError(() => this._fetchItems()); }
    if (resp.status === 503) return this.renderUnavailable();
    try { data = await resp.json(); } catch (e) { return this.renderNetworkError(() => this._fetchItems()); }
    this.items = (data && data.returnable_items) || [];
    if (!this.items.length) return this.renderState(this.t.nothing_returnable, true);
    this.renderItems();
  }

  renderItems() {
    const t = this.t;
    const rows = this.items.map((it) => {
      const id = it.fulfillment_line_item_id;
      const max = it.qty_returnable || 1;
      const qtyOpts = Array.from({ length: max }, (_, k) => `<option value="${k + 1}">${k + 1}</option>`).join('');
      return `<div class="returns-onne__item" data-item="${id}">
        <label class="returns-onne__item-head">
          <input type="checkbox" data-pick>
          <img class="returns-onne__item-photo" data-photo alt="" hidden>
          <span class="returns-onne__item-meta">
            <span class="returns-onne__item-title"></span>
            <span class="returns-onne__item-variant"></span>
          </span>
        </label>
        <div class="returns-onne__item-controls" hidden>
          <label class="support-onne__label">${t.qty}
            <select data-qty>${qtyOpts}</select>
          </label>
          <label class="support-onne__label">${t.motivo_label}
            <select data-motivo>
              <option value="otra_talla">${t.motivo_size}</option>
              <option value="no_satisfecho">${t.motivo_unwanted}</option>
              <option value="defectuoso">${t.motivo_defective}</option>
            </select>
          </label>
          <label class="support-onne__label" data-sub-wrap>${' '}
            <select data-sub>
              <option value="pequena">${t.size_smaller}</option>
              <option value="grande">${t.size_bigger}</option>
            </select>
          </label>
        </div>
      </div>`;
    }).join('');
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      ${this._stepper(1)}
      <div class="support-onne__card">
        <p class="returns-onne__items-title">${t.items_title}</p>
        ${rows}
        <p class="support-onne__error" data-sel-err hidden></p>
        <button class="support-onne__btn" type="button" data-continue>${t.cta_continue}</button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    // titles + variant + photo via textContent/src (avoid injection)
    this.items.forEach((it) => {
      const sel = `[data-item="${CSS.escape(String(it.fulfillment_line_item_id))}"]`;
      const row = this.root.querySelector(sel);
      if (!row) return;
      const titleEl = row.querySelector('.returns-onne__item-title');
      if (titleEl) titleEl.textContent = it.title || '—';
      const varEl = row.querySelector('.returns-onne__item-variant');
      if (varEl) varEl.textContent = it.color || it.variant_title || '';
      const photo = row.querySelector('[data-photo]');
      if (photo && it.image_url && /^https?:\/\//i.test(it.image_url)) {
        photo.src = it.image_url;
        photo.alt = it.title || '';
        photo.hidden = false;
      }
    });
    this.root.querySelectorAll('.returns-onne__item').forEach((row) => {
      const pick = row.querySelector('[data-pick]');
      const controls = row.querySelector('.returns-onne__item-controls');
      const motivo = row.querySelector('[data-motivo]');
      const subWrap = row.querySelector('[data-sub-wrap]');
      const syncSub = () => { subWrap.hidden = motivo.value !== 'otra_talla'; };
      pick.addEventListener('change', () => { controls.hidden = !pick.checked; syncSub(); });
      motivo.addEventListener('change', syncSub);
      syncSub();
      controls.hidden = true;
    });
    this.root.querySelector('[data-continue]').addEventListener('click', () => this._collectAndConfirm());
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderIdentify());
  }

  _collectAndConfirm() {
    const sel = [];
    this.root.querySelectorAll('.returns-onne__item').forEach((row) => {
      const pick = row.querySelector('[data-pick]');
      if (!pick.checked) return;
      const id = row.getAttribute('data-item');
      const qty = parseInt(row.querySelector('[data-qty]').value, 10) || 1;
      const motivo = row.querySelector('[data-motivo]').value;
      const sub = motivo === 'otra_talla' ? row.querySelector('[data-sub]').value : undefined;
      sel.push({ fulfillment_line_item_id: id, qty, motivo, sub_choice: sub });
    });
    if (!sel.length) {
      const e = this.root.querySelector('[data-sel-err]'); e.textContent = this.t.need_selection; e.hidden = false; return;
    }
    this.selection = sel;
    if (sel.some((s) => s.motivo === 'defectuoso')) { this.renderDefective(); return; }
    this.renderConfirm();
  }

  // ---------------------------------------------------------------- Step 3: hygiene confirm
  renderConfirm() {
    const t = this.t;
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      ${this._stepper(2)}
      <div class="support-onne__card support-onne__card--narrow">
        <p class="returns-onne__items-title">${t.hygiene_title}</p>
        <label class="returns-onne__check"><input type="checkbox" data-h> <span>${t.hcheck1}</span></label>
        <label class="returns-onne__check"><input type="checkbox" data-h> <span>${t.hcheck2}</span></label>
        <label class="returns-onne__check"><input type="checkbox" data-h> <span>${t.hcheck3}</span></label>
        <p class="support-onne__help">${t.hygiene_note}</p>
        <p class="support-onne__error" data-h-err hidden></p>
        <button class="support-onne__btn" type="button" data-submit>${t.cta_submit}</button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    this.root.querySelector('[data-submit]').addEventListener('click', () => {
      const all = [...this.root.querySelectorAll('[data-h]')].every((c) => c.checked);
      if (!all) { const e = this.root.querySelector('[data-h-err]'); e.textContent = this.t.need_hygiene; e.hidden = false; return; }
      this._submit();
    });
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderItems());
  }

  // ---------------------------------------------------------------- Step 3b: defective (photos)
  renderDefective() {
    const t = this.t;
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      ${this._stepper(2)}
      <div class="support-onne__card support-onne__card--narrow">
        <p class="returns-onne__items-title">${t.defective_title}</p>
        <p class="support-onne__help" style="margin-top:0">${t.defective_intro}</p>
        <div class="support-onne__field">
          <label class="support-onne__label" for="r-note">${t.defective_note_label}</label>
          <textarea class="support-onne__input" id="r-note" rows="3" placeholder="${t.defective_note_ph}" style="resize:vertical"></textarea>
        </div>
        <div class="support-onne__field">
          <label class="support-onne__label" for="r-photos">${t.defective_photos_label}</label>
          <input class="support-onne__input" id="r-photos" type="file" accept="image/*" multiple style="padding:0.5rem">
          <p class="support-onne__help">${t.defective_photos_hint}</p>
          <p class="support-onne__error" data-ph-err hidden></p>
        </div>
        <button class="support-onne__btn" type="button" data-send>${t.cta_send_defective}</button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    this.root.querySelector('[data-send]').addEventListener('click', () => this._submitDefective());
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderReturnType());
  }

  async _submitDefective() {
    const t = this.t;
    const noteEl = this.root.querySelector('#r-note');
    const note = noteEl ? noteEl.value.trim() : '';
    const input = this.root.querySelector('#r-photos');
    const files = input && input.files ? Array.from(input.files).slice(0, 3) : [];
    const errEl = this.root.querySelector('[data-ph-err]');
    for (const f of files) {
      if (f.size > 5 * 1024 * 1024 || !/^image\//.test(f.type || '')) {
        errEl.textContent = t.defective_photos_hint; errEl.hidden = false; return;
      }
    }
    this.renderLoading();
    if (this.demo) { return this.renderDone({ message: null }); }
    const fd = new FormData();
    fd.append('casuistica', 'defectuoso');
    fd.append('lang', this.lang);
    if (this.token) fd.append('support_session_token', this.token);
    if (this.factorEmail) fd.append('partner_email', this.factorEmail);
    if (note) fd.append('note', note);
    files.forEach((f, i) => fd.append('photo' + (i + 1), f));
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/escalate'), { method: 'POST', body: fd });
    } catch (e) { return this.renderNetworkError(() => this.renderDefective()); }
    if (resp.status === 503) return this.renderUnavailable();
    try { data = await resp.json(); } catch (e) { return this.renderNetworkError(() => this.renderDefective()); }
    return this.renderDone({ message: (data && data.message) || null });
  }

  // ---------------------------------------------------------------- Submit
  async _submit() {
    this.renderLoading();
    const payload = {
      support_session_token: this.token,
      items: this.selection.map((s) => ({ fulfillment_line_item_id: s.fulfillment_line_item_id, qty: s.qty, motivo: s.motivo, sub_choice: s.sub_choice, hygiene_attestation: true })),
      lang: this.lang,
    };
    if (this.demo) return this.renderDone({ status: 'requested', message: null, new_order_cta: this.selection.some(s => s.motivo === 'otra_talla') });
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/return/create'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      });
    } catch (e) { return this.renderNetworkError(() => this._submit()); }
    if (resp.status === 503) return this.renderUnavailable();
    try { data = await resp.json(); } catch (e) { return this.renderNetworkError(() => this._submit()); }
    if (data && (data.escalated || data.ticket_ref || data.escalated_to)) return this.renderState(data.message || this.t.service_unavailable, true);
    if (data && data.hygiene_block) return this.renderState(data.message || this.t.hygiene_note, true);
    if (data && (data.status === 'requested' || data.status === 'open' || data.return_id)) {
      return this.renderDone({ status: data.status, message: data.message, new_order_cta: data.new_order_cta });
    }
    return this.renderState(this.t.service_unavailable, true);
  }

  // ---------------------------------------------------------------- Step 4: done
  renderDone({ message, new_order_cta }) {
    const t = this.t;
    const sizeBlock = new_order_cta
      ? `<p class="support-onne__help" style="margin-top:1rem">${t.size_change_note}</p><a class="support-onne__btn order-status-onne__track" href="/collections/all">${t.new_order_cta}</a>`
      : '';
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      ${this._stepper(3)}
      <div class="support-onne__card support-onne__card--narrow support-onne__state">
        <p class="support-onne__state-msg js-msg"></p>
        ${sizeBlock}
        ${this._talk()}
      </div>
    `);
    this.root.querySelector('.js-msg').textContent = message || (this.t.steps[3]);
  }

  // ---------------------------------------------------------------- generic states
  renderState(msg, withTeam) {
    this._set(`<div class="support-onne__state support-onne__card support-onne__card--narrow">
      <p class="support-onne__state-msg js-msg"></p>${withTeam ? this._talk() : ''}</div>`);
    this.root.querySelector('.js-msg').textContent = msg;
  }
  renderUnavailable() { this.renderState(this.t.service_unavailable, true); }
  // "I can't find my order number" → resolve it for the customer. Ask email +
  // phone(last4)/postal code → /order/find. On success we get a verified session
  // token (valid for the 'return' action), so we go straight into the items.
  renderNoOrder() {
    const t = this.t;
    this._set(`
      <h1 class="support-onne__title">${t.find_title}</h1>
      <p class="support-onne__subtitle">${t.find_intro}</p>
      <form class="support-onne__card support-onne__card--narrow" data-find-form novalidate>
        <div class="support-onne__field" data-field-femail>
          <label class="support-onne__label" for="r-femail">${t.find_email_label}</label>
          <input class="support-onne__input" id="r-femail" type="email" autocomplete="off" placeholder="${t.find_email_ph}" />
          <p class="support-onne__error" data-err-femail hidden></p>
        </div>
        <div class="support-onne__field" data-field-ffactor>
          <label class="support-onne__label" for="r-ffactor">${t.find_factor_label}</label>
          <input class="support-onne__input" id="r-ffactor" type="text" autocomplete="off" placeholder="${t.find_factor_ph}" />
          <p class="support-onne__error" data-err-ffactor hidden></p>
        </div>
        <input type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true" data-hp
               style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0" />
        <button class="support-onne__btn" type="submit" data-submit>${t.find_cta}</button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>← ${t.cta_start}</button>
      </form>
    `);
    const form = this.root.querySelector('[data-find-form]');
    form.addEventListener('submit', (e) => { e.preventDefault(); this._onSubmitFind(form); });
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderIdentify());
  }

  _detectFindFactor(raw) {
    const v = (raw || '').trim();
    if (!v) return null;
    if (/^\d{4}$/.test(v)) return { phone_last4: v };
    return { postal_code: v.toUpperCase() };
  }

  _onSubmitFind(form) {
    const t = this.t;
    form.querySelectorAll('.support-onne__field').forEach(f => f.classList.remove('support-onne__field--error'));
    form.querySelectorAll('.support-onne__error').forEach(e => { e.hidden = true; });
    const email = form.querySelector('#r-femail').value.trim();
    const factor = this._detectFindFactor(form.querySelector('#r-ffactor').value.trim());
    let bad = false;
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { this._fieldErr(form, 'femail', t.need_email); bad = true; }
    if (!factor) { this._fieldErr(form, 'ffactor', t.need_find_factor); bad = true; }
    if (bad) return;
    const hpEl = form.querySelector('[data-hp]');
    this._findOrder(email, factor, hpEl ? hpEl.value : '');
  }

  async _findOrder(email, factor, hp) {
    this.renderLoading();
    if (!this.endpoint) return this.renderUnavailable();
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/order/find'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, second_factor: factor, hp: hp || '', lang: this.lang }),
      });
    } catch (e) { return this.renderNetworkError(() => this._findOrder(email, factor, hp)); }
    if (resp.status === 503) return this.renderUnavailable();
    try { data = await resp.json(); } catch (e) { return this.renderNetworkError(() => this._findOrder(email, factor, hp)); }
    if (!data || !data.found || data.verified !== true || !data.support_session_token) {
      return this.renderFindNotFound();
    }
    // Found + verified → reuse the token to go straight into the return items.
    this.token = data.support_session_token;
    this.order = data.order_name || null;
    this._fetchItems();
  }

  renderFindNotFound() {
    this._set(`<div class="support-onne__state support-onne__card support-onne__card--narrow">
      <p class="support-onne__state-msg">${this.t.find_not_found}</p>${this._talk()}
      <button class="support-onne__link support-onne__link--center" type="button" data-back>← ${this.t.cta_start}</button></div>`);
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderIdentify());
  }
  renderNetworkError(retryFn) {
    this._set(`<div class="support-onne__state support-onne__card support-onne__card--narrow">
      <p class="support-onne__state-msg">${this.t.network_error}</p>
      <button class="support-onne__btn" type="button" data-retry>${this.t.retry}</button></div>`);
    this.root.querySelector('[data-retry]').addEventListener('click', retryFn);
  }

  _demoItems() {
    return [
      { fulfillment_line_item_id: 'demo-1', title: 'Brela One-Piece — Black — M', qty_returnable: 1 },
      { fulfillment_line_item_id: 'demo-2', title: 'Tanda Bikini Top — Sand — S', qty_returnable: 2 },
    ];
  }
}

if (!customElements.get('returns-onne')) {
  customElements.define('returns-onne', ReturnsOnne);
}
